module.exports = __webpack_public_path__ + "static/media/bg_dark.7c31d87b.jpg";